import React from "react";
import { connect } from "react-redux";
import { config } from "config";
import { STATIC_URLS } from "consts";

const restrictedRestorePathsPopup = props => {
  return (
    <div class="res_original_location">
      <p>
        "Restore to Original Location" is disabled because your selection
        contains system or application-related files/folders. Restoring these
        files to their original paths can cause system instability or boot
        issues.
      </p>
      <strong>To proceed:</strong>
      <ul>
        <li>➤ Select a custom restore destination, OR</li>
        <li>
          ➤ Remove system folders from your selection to restore remaining files
          to their original location.
        </li>
        <li>
          For more information, refer to the{" "}
          <a
            href={
              STATIC_URLS.origLocRestore[
                props?.origin === "idrive" ? "idrive" : config.APP_INSTANCE
              ]
            }
            target="_blank"
          >
            FAQ
          </a>
          .
        </li>
      </ul>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    origin: state.account.origin
  };
}

export default connect(mapStateToProps)(restrictedRestorePathsPopup);
